import {
  Box,
  Grid2,
  IconButton,
  Stack,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import QueryIcon from "assets/svg/QueryIcon";
import SettingsIcon from "assets/svg/SettingsIcon";
import { AxiosError, AxiosResponse } from "axios";
import AdminPageCardTitle from "components/AdminPageCardTitle/AdminPageCardTitle";
import PrimaryButton from "components/PrimaryButton/PrimaryButton";
import SecondaryButton from "components/SecondaryButton/SecondaryButton";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { MailerConfigData, MailerConfigResponse } from "reduxStore/dataTypes";
import { fetchMailerConfig, updateConfigGroup } from "services/apiService";
import theme, { responsiveFontSize } from "themes/Theme";

interface ConfigProps {
  id: number;
  groupTag: string;
  configKey: string;
  configValue: string;
  description: string;
}

const SettingsPage = () => {
  const [editable, setEditable] = useState(false);
  const [editEmail, setEditEmail] = useState(false);
  const [mailerConfig, setMailerConfig] = useState<MailerConfigData[]>([]);
  const [currencyConfig, setCurrencyConfig] = useState<MailerConfigData[]>([]);
  const [editableConfig, setEditableConfig] = useState<ConfigProps[]>([]);
  const [value, setValue] = useState(0);

  const toggleEditable = () => {
    setEditable(!editable);
  };

  const getEmailConfig = async () => {
    try {
      const response: AxiosResponse<MailerConfigResponse> =
        await fetchMailerConfig("mailer");
      setMailerConfig(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getCurrencyConfig = async () => {
    try {
      const response: AxiosResponse<MailerConfigResponse> =
        await fetchMailerConfig("currency");
      setCurrencyConfig(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getEmailConfig();
    getCurrencyConfig();
  }, []);

  const getFieldValue = (configKey: string) => {
    const configList = value === 0 ? currencyConfig : mailerConfig;
    return configList.find((element) => element.configKey === configKey);
  };

  const getEditableFieldValue = (configKey: string) => {
    return editableConfig.find((element) => element.configKey === configKey);
  };

  const updateFields = (fieldName: string, value: string) => {
    const config = getFieldValue(fieldName);
    if (config) {
      setEditableConfig((prevConfig) => {
        const existingConfigIndex = prevConfig.findIndex(
          (element) => element.configKey === fieldName
        );

        if (existingConfigIndex !== -1) {
          // Create a new array with updated value to avoid direct mutation
          const updatedConfig = [...prevConfig];
          updatedConfig[existingConfigIndex] = {
            ...updatedConfig[existingConfigIndex],
            configValue: value,
          };
          return updatedConfig;
        } else {
          // Add new config entry if it doesn't exist
          return [
            ...prevConfig,
            {
              id: config.id,
              groupTag: config.groupTag,
              configKey: config.configKey,
              configValue: value, // Use the new value
              description: config.description,
            },
          ];
        }
      });
    } else {
      console.log("No config found for fieldName:", fieldName);
    }
  };

  const handleSubmitConfig = async (type: string) => {
    try {
      const response = await updateConfigGroup(type, editableConfig);
      if (response && response.status === 200) {
        toast.success(response?.data?.message);
        setEditableConfig([]);
        if (type === "mailer") {
          getEmailConfig();
        } else {
          getCurrencyConfig();
        }
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue === 0) {
      getCurrencyConfig();
    } else {
      getEmailConfig();
    }
    setValue(newValue);
  };

  return (
    <Box sx={styles.container}>
      <AdminPageCardTitle
        title={"Settings"}
        icon={<SettingsIcon width={28} height={28} />}
      />
      <Tabs
        value={value}
        onChange={handleChange}
        sx={{ mt: 2 }}
        aria-label="basic tabs example"
      >
        {/* <Tab
          label={
            <Typography
              sx={{
                fontSize: responsiveFontSize(14),
                fontWeight: 400,
                textTransform: "capitalize",
              }}
            >
              Mail Settings
            </Typography>
          }
        /> */}
        <Tab
          label={
            <Typography
              sx={{
                fontSize: responsiveFontSize(14),
                fontWeight: 400,
                textTransform: "capitalize",
              }}
            >
              Currency Settings
            </Typography>
          }
        />
      </Tabs>
{/* 
      {value === 0 && (
        <>
          <Grid2 container spacing={2} mt={2}>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>Server</Typography>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                fullWidth
                value={
                  getEditableFieldValue("server")?.configValue ||
                  getFieldValue("server")?.configValue
                }
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter server"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("server", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Stack direction="row" alignItems="center" spacing={0.3}>
                <Typography sx={styles.inputLabelStyle}>
                  Support Email Address
                </Typography>
                <Tooltip
                  title={getFieldValue("user_support_email")?.description}
                  placement="top"
                >
                  <IconButton>
                    <QueryIcon />
                  </IconButton>
                </Tooltip>
              </Stack>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                fullWidth
                value={
                  getEditableFieldValue("user_support_email")?.configValue ||
                  getFieldValue("user_support_email")?.configValue
                }
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter email address"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("user_support_email", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Stack direction="row" alignItems="center" spacing={0.3}>
                <Typography sx={styles.inputLabelStyle}>
                  Dev Team Email Address
                </Typography>
                <Tooltip
                  title={getFieldValue("devteam_email")?.description}
                  placement="top"
                >
                  <IconButton>
                    <QueryIcon />
                  </IconButton>
                </Tooltip>
              </Stack>

              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                value={
                  getEditableFieldValue("devteam_email")?.configValue ||
                  getFieldValue("devteam_email")?.configValue
                }
                fullWidth
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter email address"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("devteam_email", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Stack direction="row" alignItems="center" spacing={0.3}>
                <Typography sx={styles.inputLabelStyle}>
                  Contact Email Address
                </Typography>
                <Tooltip
                  title={getFieldValue("contact_email")?.description}
                  placement="top"
                >
                  <IconButton>
                    <QueryIcon />
                  </IconButton>
                </Tooltip>
              </Stack>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                fullWidth
                value={
                  getEditableFieldValue("contact_email")?.configValue ||
                  getFieldValue("contact_email")?.configValue
                }
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter contact email address"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("contact_email", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Stack direction="row" alignItems="center" spacing={0.3}>
                <Typography sx={styles.inputLabelStyle}>
                  From Address
                </Typography>
                <Tooltip
                  title={getFieldValue("from_address")?.description}
                  placement="top"
                >
                  <IconButton>
                    <QueryIcon />
                  </IconButton>
                </Tooltip>
              </Stack>

              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                value={
                  getEditableFieldValue("from_address")?.configValue ||
                  getFieldValue("from_address")?.configValue
                }
                fullWidth
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter from email address"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("from_address", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>SMTP Host</Typography>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                value={
                  getEditableFieldValue("host")?.configValue ||
                  getFieldValue("host")?.configValue
                }
                fullWidth
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter SMTP Host"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("host", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>User Name</Typography>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                value={
                  getEditableFieldValue("username")?.configValue ||
                  getFieldValue("username")?.configValue
                }
                fullWidth
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter user name"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("username", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>
                Sender Address
              </Typography>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                value={
                  getEditableFieldValue("from_address")?.configValue ||
                  getFieldValue("from_address")?.configValue
                }
                fullWidth
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter sender email address"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("from_address", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>Password</Typography>
              <TextField
                type="password"
                margin="dense"
                variant="outlined"
                size="small"
                fullWidth
                value={
                  getEditableFieldValue("password")?.configValue ||
                  getFieldValue("password")?.configValue
                }
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter password"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("password", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>Port</Typography>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                fullWidth
                value={
                  getEditableFieldValue("port")?.configValue ||
                  getFieldValue("port")?.configValue
                }
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="eg. 465"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("port", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
          </Grid2>
          <Box sx={styles.rightAlign} mt={1} mb={3}>
            <Box mr={3}>
              <SecondaryButton
                title="Discard"
                onClick={() => {
                  setEditableConfig([]);
                  getEmailConfig();
                }}
              />
            </Box>
            <PrimaryButton
              title="Save Changes"
              onClick={() => handleSubmitConfig("mailer")}
            />
          </Box>
        </>
      )} */}
      {value === 0 && (
        <>
          <Grid2 container spacing={2} mt={2}>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>Name</Typography>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                fullWidth
                value={
                  getEditableFieldValue("name")?.configValue ||
                  getFieldValue("name")?.configValue
                }
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter currency name"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("name", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>
                Blockchain Name
              </Typography>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                value={
                  getEditableFieldValue("blockchain")?.configValue ||
                  getFieldValue("blockchain")?.configValue
                }
                fullWidth
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter blockchain name"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("blockchain", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>Ticker</Typography>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                value={
                  getEditableFieldValue("ticker")?.configValue ||
                  getFieldValue("ticker")?.configValue
                }
                fullWidth
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter ticker"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("ticker", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>RPC URL</Typography>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                value={
                  getEditableFieldValue("rpc_url")?.configValue ||
                  getFieldValue("rpc_url")?.configValue
                }
                fullWidth
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter rpc url"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("rpc_url", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>Explorer URL </Typography>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                value={
                  getEditableFieldValue("explorer_url")?.configValue ||
                  getFieldValue("explorer_url")?.configValue
                }
                fullWidth
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter explorer url"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("explorer_url", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>Icon URL</Typography>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                fullWidth
                value={
                  getEditableFieldValue("icon_url")?.configValue ||
                  getFieldValue("icon_url")?.configValue
                }
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter icon url"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("icon_url", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>Chain ID</Typography>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                fullWidth
                value={
                  getEditableFieldValue("chain_id")?.configValue ||
                  getFieldValue("chain_id")?.configValue
                }
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter chain id"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("chain_id", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>
                Transaction Pool Address
              </Typography>
              <TextField
                type="text"
                margin="dense"
                variant="outlined"
                size="small"
                fullWidth
                value={
                  getEditableFieldValue("txPoolAccount_address")?.configValue ||
                  getFieldValue("txPoolAccount_address")?.configValue
                }
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter transaction pool address"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("txPoolAccount_address", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography sx={styles.inputLabelStyle}>
                Transaction Pool Private Key
              </Typography>
              <TextField
                type="password"
                margin="dense"
                variant="outlined"
                size="small"
                fullWidth
                value={
                  getEditableFieldValue("txPoolAccount_privateKey")
                    ?.configValue ||
                  getFieldValue("txPoolAccount_privateKey")?.configValue
                }
                sx={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
                placeholder="Enter transaction pool private key"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateFields("txPoolAccount_privateKey", e.target.value);
                }}
                slotProps={styles.inputSlotTextStyle}
              />
            </Grid2>
          </Grid2>
          <Box sx={styles.rightAlign} mt={1} mb={3}>
            <Box mr={3}>
              <SecondaryButton
                title="Discard"
                onClick={() => {
                  setEditableConfig([]);
                  getEmailConfig();
                }}
              />
            </Box>
            <PrimaryButton
              title="Save Changes"
              onClick={() => handleSubmitConfig("currency")}
            />
          </Box>
        </>
      )}
    </Box>
  );
};
export default SettingsPage;
const styles = {
  container: {
    flexGrow: 1,
    borderRadius: 3,
    boxShadow: `rgba(8, 60, 61, 0.27) 0px 1px 5px 0px, rgba(8, 60, 61, 0.06) 0px 1px 5px 0px`,
    backgroundColor: "rgb(255, 255, 255)",
    p: 3,
    ml: { xs: 0, md: -5 },
  },
  inputLabelStyle: {
    fontSize: responsiveFontSize(14),
    fontWeight: 500,
    color: theme.palette.custom?.black,
    marginTop: "1em",
    marginBottom: "0.3em",
  },
  inputSlotTextStyle: {
    input: {
      sx: {
        fontSize: "0.875rem",
        color: theme.palette.text.primary,
        fontWeight: 400,
      },
    },
  },
  rightAlign: {
    display: "flex",
    flexDirection: "row",
    alignItems: "right",
    justifyContent: "right",
    width: "100%",
  },
};
